import { ref, watch } from "vue";

// The preview requests list owns its data (PreviewRequests.vue), while what changes a
// row — such as saving a new photo position — happens in modals opened from the column
// definitions, far from the table's own events. A shared counter lets them ask the list
// to reload from the server.
const refreshRequests = ref(0);

export const requestPreviewRequestsRefresh = () => {
  refreshRequests.value += 1;
};

// Call from the list's setup; the watcher stops with the component.
export const onPreviewRequestsRefresh = (reload) => watch(refreshRequests, () => reload());
